import React from 'react';
import { Customers, EntityType } from '../../../entity.types';
import { cleanObject, cleanResults } from '../chartTypologies.utils';
import {
  CompanySizeTypologiesPresentation,
  CompanySizeTypologiesChart,
} from '..';

type Props = {
  customers: Customers;
  decisionCount: number;
  entityType: EntityType;
  entityId: string;
  entityName: string;
};

type State = {
  sizesData: Array<number>;
  sizesLabels: Array<string>;
};

export class CompanySizeTypologies extends React.Component<Props, State> {
  state: State = {
    sizesData: [],
    sizesLabels: [],
  };

  componentDidMount() {
    const { enterpriseSizes } = cleanResults(this.props.customers);
    let sizesData = null;
    let sizesLabels = null;
    if (enterpriseSizes !== null) {
      const cleanEnterpriseSizes = cleanObject(enterpriseSizes);
      sizesData = cleanEnterpriseSizes.map((d) => Math.round(d[1]));
      sizesLabels = cleanEnterpriseSizes.map((c) => c[0]);
      this.setState({ sizesData, sizesLabels });
    }
  }

  render() {
    const { decisionCount, entityType, entityName, entityId } = this.props;
    const { sizesLabels, sizesData } = this.state;
    const entityInfos = {
      decisionCount,
      entityType,
      entityName,
      entityId,
    };

    if (sizesLabels.length === 0 || sizesData.length === 0) {
      return null;
    }

    return (
      <CompanySizeTypologiesPresentation {...entityInfos}>
        <CompanySizeTypologiesChart
          sizesLabels={sizesLabels}
          sizesData={sizesData}
        />
      </CompanySizeTypologiesPresentation>
    );
  }
}
